import { api } from "../api/api";

export interface IAnalyticsUserActionEvent {
    type: 'user_action';
    component: string;
    action: string;
    controlName: string;
    value?: string;
    metadata?: Record<string, any>;
}

export interface IErrorEvent {
    type: 'error';
    errorType: string;
    message: string;
    stack?: string;
    component?: string;
    context: Record<string, any>;
}

export type AnalyticsEvent = IAnalyticsUserActionEvent | IErrorEvent;

export interface IAnalyticsEventDto {
    sessionId: string;
    userId?: number;
    url: string;
    userAgent: string;
    operdate: string;
    event: AnalyticsEvent;
}

export interface ErrorContext {
    type: string;
    component?: string;
    [key: string]: any;
}

class AnalyticsService {
    public async track(eventData: AnalyticsEvent): Promise<void> {
        try {
            const payload: IAnalyticsEventDto = {
                sessionId: this.getSessionId(),
                userId: this.getUserId(),
                url: window.location.href,
                userAgent: navigator.userAgent,
                operdate: new Date().toISOString(),
                event: eventData,
            };

            await api.post('/analytics', payload);
        } catch (error) {
            console.warn('Analytics error:', error);
        }
    }

    public captureException(error: Error, context: ErrorContext): void {
        const errorEvent: IErrorEvent = {
            type: 'error',
            errorType: context.type,
            message: error.message,
            stack: error.stack,
            component: context.component,
            context: context,
        };

        this.track(errorEvent);
    }

    public captureAction(action: string, component: string, controlName: string, additionalData: Record<string, any> = {}): void {
        const { value, ...data } = additionalData;
        const userActionEvent: IAnalyticsUserActionEvent = {
            type: 'user_action',
            action: action,
            component: component,
            controlName: controlName,
            value: value,
            metadata: data,
        };

        this.track(userActionEvent);
    }

    private getUserId(): number | undefined {
        const userId = localStorage.getItem('userId') ?? 0;
        return +userId;
    }

    private getSessionId(): string {
        let sessionId = sessionStorage.getItem('sessionId');
        if (!sessionId) {
            sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            sessionStorage.setItem('sessionId', sessionId);
        }
        return sessionId;
    }
}

export const analytics = new AnalyticsService();